/**
 * @generated SignedSource<<f72861d381652b531e03ae88e59c138e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WAEmployeeScheduleQuery$variables = Record<PropertyKey, never>;
export type WAEmployeeScheduleQuery$data = {
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleSettingsQuery_store">;
  };
};
export type WAEmployeeScheduleQuery = {
  response: WAEmployeeScheduleQuery$data;
  variables: WAEmployeeScheduleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAEmployeeScheduleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetEmployeeScheduleSettingsQuery_store"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WAEmployeeScheduleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myRole",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeScheduleType",
            "kind": "LinkedField",
            "name": "employeeScheduleTypes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeams",
                "plural": true,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b3e20999e97f22c1219fa56fd9d7e63",
    "id": null,
    "metadata": {},
    "name": "WAEmployeeScheduleQuery",
    "operationKind": "query",
    "text": "query WAEmployeeScheduleQuery {\n  store {\n    ...WidgetEmployeeScheduleSettingsQuery_store\n    id\n  }\n}\n\nfragment ManageEmployeeSchedueTypesListItem_store on Store {\n  employeeScheduleTypes {\n    id\n    assignedTeams {\n      id\n    }\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n\nfragment WidgetEmployeeScheduleSettingsQuery_store on Store {\n  myRole\n  publicTeams {\n    ...TeamSelectList_Team\n    id\n  }\n  ...ManageEmployeeSchedueTypesListItem_store\n}\n"
  }
};
})();

(node as any).hash = "11d8ab8a2039355afaa7e3cf5226f664";

export default node;
